<template>
  <!-- <p>Please resolve the following before continuing</p>

  <div v-if="conflictsToResolve.templates">
    Template Conflicts Fully Resolved: {{ templateConflictsResolved }}
  </div>

  <div v-if="conflictsToResolve.assets">
    Assets Conflicts Resolved: {{ assetConflictsResolved }}
  </div>

  <div>
    Total Conflicts to Resolve: {{ totalConflictsResolved }} /
    {{ totalConflicts }}
  </div>

  allConflictsResolved: {{ allConflictsResolved }} -->
  <ConflictWizard
    v-if="customState"
    :conflictResult="customState" />
  <!--
  <div
    class="conflict-container"
    v-if="conflictsToResolve.templates">
    <div>Templates with Conflicts: {{ templatesWithConflicts }}</div>

    <div>
      Total Template Conflicts to Resolve: {{ resolvedTemplateConflicts }} /
      {{ templateConflictTotal }}
    </div>

    <ConflictWizard
      :conflicts="conflictsToResolve.templates"
      type="templates" />
  </div> -->

  <!-- <div
    class="conflict-container"
    v-if="conflictsToResolve.assets">
    Assets with Conflicts: {{ assetsWithConflicts }} -->
  <!-- <ConflictWizard
      :conflicts="conflictsToResolve.assets"
      type="assets" /> -->
  <!-- </div> -->
</template>
<script setup lang="ts">
import { ref, readonly, computed } from 'vue';
import ConflictWizard from './ConflictWizard.vue';

// Types
import type {
  ConflictResult,
  TemplateConflictInfo,
  AssetConflictInfo,
} from './conflictResultDefinition';
import type { Ref } from 'vue';
//

// userEditObj is the not needed but stops console complaining about injecting
const props = defineProps(['customState', 'userEditObj']);
</script>
<style scoped>
.conflict-container {
  margin: 10px;
  padding: 10px;
  border: 1px solid green;
}
</style>
